import { Lakemedel, LakemedelDisplay } from "@/tabs/Receptforskrivning/types";

/**
 * Ändra strukturen på data direkt från SIL till format mer anpassat till FE
 */
export const convertLakemedelData: (ars: { lakemedel?: Lakemedel }) => LakemedelDisplay | null = ({ lakemedel }) => {
    if (!lakemedel) {
        return null;
    }

    const namn = lakemedel.distributedTradeName;
    const tillverkare = lakemedel.intressent;
    const styrka = lakemedel.strengthText;
    const form = lakemedel.drugFormTextSv;
    const forpackningsinnehall = lakemedel.packageText;
    const substans = lakemedel.substanceDescription;
    const atc = lakemedel.atcCode;

    return {
        namn,
        tillverkare,
        /**
         * Samma värde som nplPackId. Används som ett unikt värde i store (eftersom nplPackId är unika värden)
         */
        id: lakemedel.id,
        forpackning: lakemedel.packageText,
        form,
        linkFass: lakemedel.linkFASS,
        substans,
        styrka,
        atc,
        lakemedel: {
            namn,
            tillverkare,
            styrka,
            form,
            forpackningsinnehall,
            substans,
            atc,
        },
        kontrollerat: lakemedel.controlledDrugFlag,
        rekommenderat: lakemedel.isRecommended,
        restnoterat: lakemedel.hasShortage,
        formansrestriktion: lakemedel.limitedReimbursement,
        /**
         * Skickas till BE för hämtning av mer data för läkemedel, oftast i kombination med nplPackId
         */
        nplId: lakemedel.nplId,
        /**
         * Skickas till BE för hämtning av mer data för läkemedel, oftast i kombination med nplId
         */
        nplPackId: lakemedel.nplPackId,
        inomForman: lakemedel.isReimbursed,
        narkotikaNiva: lakemedel.controlClass ? lakemedel.controlClass : -1,
        mangd: lakemedel.packSizeNumeric,
    };
};
